import { DatePipe } from '@angular/common';
import { Injectable, inject } from '@angular/core';

@Injectable()
export class DatesService {
  static FINAL_FORMAT = 'MMM dd, yyyy';
  private readonly datePipe = inject(DatePipe);

  getCurrentDatePlusOneYear = (): string | null => {
    const currentDate = new Date();
    const currentDatePlusOneYear = new Date(
      currentDate.getFullYear() + 1,
      currentDate.getMonth(),
      currentDate.getDate()
    );
    return this.datePipe.transform(currentDatePlusOneYear, DatesService.FINAL_FORMAT);
  };

  parseDate = (value: string | number | Date): Date | null => {
    const dateString = this.datePipe.transform(value, DatesService.FINAL_FORMAT);
    return dateString != null ? new Date(dateString) : dateString;
  };
}
